/*
 * @format
 */

import * as actionTypes from '../action-types';

export const initialState = {
  requestState: null,
  title: '',
  message: '',
};

export const deviceGeoStatus = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GEOLOCATION_LOCATION_CONFIRMATION_PENDING:
      return {
        requestState: 'Pending',
        title: 'Updating device location',
        message: "Waiting for your device to confirm it's location",
      };

    case actionTypes.GEOLOCATION_LOCATION_CONFIRMATION_FAILED:
      return {
        requestState: 'Failed',
        title: 'Waiting for Location',
        message: 'Your home/away status may take a short time to appear',
      };

    case actionTypes.GEOLOCATION_LOCATION_CONFIRMATION_CLEAR:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
